'use client';

import * as React from 'react';
import { motion, useAnimation, type Variants } from 'framer-motion';

interface IconProps {
	isHovered: boolean;
}

const pathVariants: Variants = {
	normal: {
		pathLength: 1,
		opacity: 1,
		d: 'M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2',
	},
	animate: {
		pathLength: [0, 1],
		opacity: [0, 1],
		d: 'M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2',
	},
};

const circleVariants: Variants = {
	normal: {
		scale: 1,
		opacity: 1,
	},
	animate: {
		scale: [0, 1],
		opacity: [0, 1],
	},
};

export function PersonIcon({ isHovered }: IconProps) {
	const controls = useAnimation();

	React.useEffect(() => {
		void controls.start(isHovered ? 'animate' : 'normal');
	}, [isHovered, controls]);

	return (
		<div className='select-none flex items-center justify-center'>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				stroke={isHovered ? '#FF69B4' : 'currentColor'}
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			>
				<motion.path
					variants={pathVariants}
					initial='normal'
					animate={controls}
					transition={{ duration: 0.3 }}
				/>
				<motion.circle
					cx={12}
					cy={7}
					r={4}
					variants={circleVariants}
					initial='normal'
					animate={controls}
					transition={{ duration: 0.3 }}
				/>
			</svg>
		</div>
	);
}
